import { render, staticRenderFns } from "./componentLoading.vue?vue&type=template&id=18e5ffcf&scoped=true&"
import script from "./componentLoading.vue?vue&type=script&lang=js&"
export * from "./componentLoading.vue?vue&type=script&lang=js&"
import style0 from "./componentLoading.vue?vue&type=style&index=0&id=18e5ffcf&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18e5ffcf",
  null
  
)

export default component.exports